

















import {Prop, Component, Vue} from 'vue-property-decorator'

@Component({})
export default class PhotoSection extends Vue {
  @Prop({type: Array, default: () => []}) value!: string[]
  @Prop({type: Boolean, default: true}) isRequired?: boolean
  @Prop({type: String, default: ''}) title!: string
  @Prop({type: String, default: ''}) sectionName!: string
  @Prop({type: String, default: ''}) uploadButtonTitle!: string
  @Prop({type: Boolean}) hideButton!: boolean
  @Prop({type: String}) cargaImageName?: string

  changePhoto(item: string) {
    this.$emit('clickOnUpload', item)
  }
}
